import React from "react"

import { NONE, VALUE, UNLIMITED, NO, YES } from "const"
import { MtPackage } from "server/models"
import { LangType } from "client/store"
import { TableColumnEditable } from "client/components"
import TableSelect from "../components/select"
import { styleOffset } from "./index"

const Project = (lang: LangType) => {
    const columns: TableColumnEditable[] = [
        {
            field: "projectModuleAccess",
            header: lang.projectModuleAccess,
            formatter: (packg: MtPackage) => {
                const { projectModuleAccess } = packg.settingsParsed
                return lang[projectModuleAccess]
            },
            focusedFormatter: (packg: MtPackage) => {
                const { projectModuleAccess } = packg.settingsParsed
                return (
                    <TableSelect
                        text={lang[projectModuleAccess]}
                        label={lang.projectModuleAccess}
                        property={{ projectModuleAccess }}
                        propertyArray={[NO, YES]}
                    />
                )
            },
        },
        {
            field: "projects",
            header: lang.projects,
            style: styleOffset,
            formatter: (packg: MtPackage) => {
                const { projects, projectsValue } = packg.settingsParsed
                if (projects === 1) return 1
                if (projects === VALUE) return projectsValue
                if (projects === UNLIMITED) return lang.unlimited
                return null
            },
            focusedFormatter: (packg: MtPackage) => {
                const { projects, projectsValue } = packg.settingsParsed
                let title = ""
                if (projects === 1) title = "1"
                if (projects === VALUE) title = projectsValue.toString()
                if (projects === UNLIMITED) title = lang.unlimited

                return (
                    <TableSelect
                        text={title}
                        label={lang.projects}
                        property={{ projects }}
                        propertyValue={{ projectsValue }}
                        propertyArray={[1, VALUE, UNLIMITED]}
                    />
                )
            },
        },
        {
            field: "subProjects",
            header: lang.subProjects,
            style: styleOffset,
            formatter: (packg: MtPackage) => {
                const { subProjects, subProjectsValue } = packg.settingsParsed
                if (subProjects === NONE) return lang.none
                if (subProjects === VALUE) return subProjectsValue
                if (subProjects === UNLIMITED) return lang.unlimited
                return null
            },
            focusedFormatter: (packg: MtPackage) => {
                const { subProjects, subProjectsValue } = packg.settingsParsed
                let title = ""
                if (subProjects === NONE) title = lang.none
                if (subProjects === VALUE) title = subProjectsValue.toString()
                if (subProjects === UNLIMITED) title = lang.unlimited

                return (
                    <TableSelect
                        text={title}
                        label={lang.subProjects}
                        property={{ subProjects }}
                        propertyValue={{ subProjectsValue }}
                        propertyArray={[NONE, VALUE, UNLIMITED]}
                    />
                )
            },
        },
        {
            field: "projectTeamMembers",
            header: lang.projectTeamMembers,
            style: styleOffset,
            formatter: (packg: MtPackage) => {
                const { projectTeamMembers, projectTeamMembersValue } = packg.settingsParsed
                if (projectTeamMembers === 1) return 1
                if (projectTeamMembers === VALUE) return projectTeamMembersValue
                if (projectTeamMembers === UNLIMITED) return lang.unlimited
                return null
            },
            focusedFormatter: (packg: MtPackage) => {
                const { projectTeamMembers, projectTeamMembersValue } = packg.settingsParsed
                let title = ""
                if (projectTeamMembers === 1) title = "1"
                if (projectTeamMembers === VALUE) title = projectTeamMembersValue.toString()
                if (projectTeamMembers === UNLIMITED) title = lang.unlimited

                return (
                    <TableSelect
                        text={title}
                        label={lang.projectTeamMembers}
                        property={{ projectTeamMembers }}
                        propertyValue={{ projectTeamMembersValue }}
                        propertyArray={[1, VALUE, UNLIMITED]}
                    />
                )
            },
        },
    ]

    return columns
}
export default Project
